import { render, staticRenderFns } from "./SelfTerminationFeedbackModal.vue?vue&type=template&id=1ab9be35&scoped=true&"
import script from "./SelfTerminationFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./SelfTerminationFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfTerminationFeedbackModal.vue?vue&type=style&index=0&id=1ab9be35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9be35",
  null
  
)

component.options.__file = "SelfTerminationFeedbackModal.vue"
export default component.exports